<template lang="pug">
  div.citizen.appeal-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template(v-if="fields && fields.id") Обращение от {{fields.fio}}
          template(v-else) Добавление новой записи
        div.tabs
          span(@click="tabView = 'tab1'" :class="activeClass('tab1')") Общие сведения
          span(@click="tabView = 'tab2'" :class="activeClass('tab2')") Фотографии
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Обращение")

                e-form-group(
                name="fio"
                inputType="input"
                label="Фамилия"
                :model="fields"
                tabView="tab1"

                )
                e-form-group(
                name="email"
                inputType="input"
                validationRule="email"
                label="Email"
                :model="fields"
                tabView="tab1"

                )
                e-form-group(
                name="phone"
                inputType="input"
                label="Телефон"
                :model="fields"
                tabView="tab1"

                )
                e-form-group(
                name="description"
                inputType="textarea"
                label="Текст обращения"

                :model="fields"
                tabView="tab1"
                )
                  label(slot="label").dsc-lbl
                    div.txt Текст обращения
                    div.tm Подано {{fields.created_at}}

                e-form-group(
                  name="appeal_file"
                  inputType="simple-file-uploader"
                  label="Фото 1"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                )
                e-form-group(
                  name="appeal_file_2"
                  inputType="simple-file-uploader"
                  label="Фото 2"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                )
                e-form-group(
                  name="appeal_file_3"
                  inputType="simple-file-uploader"
                  label="Фото 3"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                )

                template(
                v-if="showHiddenFields === true"
                )
                  e-form-subtitle(text="Администрирование")
                  e-form-group(
                  name="number"
                  label="Номер обращения"
                  placeholder="Любой текст"
                  :model="fields"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="created_at"
                  label="Дата и время обращения"
                  placeholder="Любой текст"
                  :model="fields"
                  tabView="tab1"
                  )
                  e-form-group(
                  name="answered_at"
                  label="Дата ответа (указ здесь знач будет перезаписано если будет добавлен новый ответ)"
                  placeholder="Любой текст"
                  :model="fields"
                  tabView="tab1"
                  )
                  div
                    p Фото
                      a(@click.stop.prevent="addPhoto()") Добавить
                    div(
                    v-for="photo, index in fields.photos"
                    )
                      input(
                      type="text"
                      placeholder="http://...."
                      :key="index"
                      v-model="fields.photos[index]"
                      )
                      a(@click.stop.prevent="fields.photos.splice(index, 1)") Удалить

              div.col
                div.col-block
                  div(
                    style="visibility:hidden;"
                  ).title
                    p
                e-form-group(
                name="cat_id"
                inputType="select"
                label="Категория обращения"
                :model="fields"
                tabView="tab1"
                :options="appealCategories"
                )
                e-form-group(
                name="recipient_id"
                inputType="select"
                label="Организация - адресат"
                :model="fields"
                tabView="tab1"
                :options="[]"
                )

                e-location(
                :formValidator="formValidator"
                :model="fields"
                name="fact_address"
                :required="true"
                :addressData="addressData"
                tabView="tab1"
                )


              div.col
                e-form-subtitle(text="Ответ")

                e-form-group(
                name="answer_status_id"
                inputType="select"
                label="Статус"
                :model="fields"
                tabView="tab1"
                :options="answerStatuses"
                )
                e-form-group(
                name="answer_description"
                inputType="textarea"
                label="Текст ответа"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="answer_file"
                inputType="simple-file-uploader"
                :label="null"
                :model="fields"
                tabView="tab1"
                :uploadUrl="uploadUrl"
                )
                div(
                  v-if="fields.answers && fields.answers.length"
                ).col-block
                  div.title
                    p Ответы
                  div.answers
                    div(
                      v-for="answer, answerIndex in fields.answers"
                    ).answer
                      div.desc {{answer.answer_description}}
                      div.info
                        div.time Дата ответа: {{answer.answered_at}}
                        div(
                          v-if="answer.answer_file && answer.answer_file.name"
                        ).file Файл:&nbsp;
                          a(
                          :href="`${ROOT_DOMAIN}api/v1/${answer.answer_file.url}?ext=${answer.answer_file.ext}`"
                          ) {{answer.answer_file.name}}
                      div(
                        v-if="showHiddenFields === true"
                      ).info
                        div.time Администрирование:
                        div.file
                          a(
                            @click.stop.prevent="fields.answers.splice(answerIndex, 1)"
                          ) Удалить



          div(v-show="tabView === 'tab2'")
            div.body
              div.col
                e-image-viewer(
                :imagesArray="uploadedPhotosUrls"
                )
</template>

<script>
  import {mongoApi, core} from '../../api/api-endpoints.js'
  import appealFormMixin from  './mixins/appeal-form.js'
  import {Appeals} from '../../config/mongo'

  export default {
    mixins: [appealFormMixin],
    data () {
      return {
        tabView: 'tab1',
        fields: {}
      }
    },
    methods: {
      getUpdateOrCreateUrl () {
        if (this.$route.params.id) {
          return mongoApi.updateCollectionItem(Appeals, this.$route.params.id)
        }
        return mongoApi.createCollectionItem(Appeals)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return mongoApi.getCollectionItem(Appeals, route.params.id)
      },
      uploadUrl () {
        return core.file()
      }
    }
  }
</script>
